import React from 'react';
import { FormattedMessage } from 'react-intl';
import styles from './CarStatus.styles';

type CareStatusProps = {
  status: any;
  style?: any;
};

const CareStatus: React.FC<CareStatusProps> = ({ status, style }) => {
  return (
    <p style={style} className={status}>
      <FormattedMessage id={`fleetadmin.serviceStatus.${status}`} />
      <style jsx>{styles}</style>
    </p>
  );
};

export default CareStatus;
